import { ButtonLink, Label, SliderTab } from '@silverfort/sf-components';
import { TopMetricLayoutProps, hasTabsProps } from '../types';

const TopMetricLayout = <T extends string>(props: TopMetricLayoutProps<T>) => {
    const { children, label, onShowMore, disabled = false } = props;
    return (
        <div className="box-border flex h-full flex-1 flex-col rounded-lg border border-sf-gray-100 font-sf hover:border-sf-gray-300 bg-sf-white">
            <div className="flex h-12 items-center gap-2 py-2 pl-4 pr-2">
                <div className="flex flex-row gap-2 flex-1">
                    <Label text={label} />
                </div>
                {hasTabsProps(props) && props.tabs.length > 1 && (
                    <div className="justify-end">
                        <SliderTab
                            items={props.tabs.map((tab) => ({
                                id: tab.value,
                                label: tab.name,
                                disabled: tab.disabled
                            }))}
                            onSelect={props.onTabChange}
                            selectedId={props.selectedTab}
                        />
                    </div>
                )}
            </div>
            <div className="h-px w-full bg-sf-gray-100" />
            <div className="flex h-full flex-1 items-start justify-center p-4">{children}</div>
            <div className="h-10 ml-8">
                <ButtonLink
                    className="text-[12px] self-start"
                    underline
                    onClick={onShowMore}
                    text="Show more"
                    disabled={
                        hasTabsProps(props)
                            ? props.tabs.find((tab) => tab.value === props.selectedTab)?.disabled ?? false
                            : disabled
                    }
                />
            </div>
        </div>
    );
};

export default TopMetricLayout;
